import React from 'react';
import { priceFormat } from '../../../../util';
import * as toolSelectors from '../../../../selectors/tools';
import { getCancelAndRefundItems, getCancelOnlyItems, getRefundOnlyItems } from '../../../../extractFromState';
import { getItemNameAndQuantity, getItemPrice } from '../helpers';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { ResultsColumn, ResultsColumnHeader, Row, HeaderRow, SubTitleText, Spreadsheet } from '../DTInfoWidget.styles';

const DTCancelAndRefundWidget = () => {
  const orderingSystem = useSelector(toolSelectors.getOrderingSystem);
  const selectedLineItems = useSelector(toolSelectors.getSelectedLineItems);
  const lineItemsOfSelectedOrder = useSelector(toolSelectors.getLineItemsOfSelectedOrder);
  const refundOnlyItems = useSelector(getRefundOnlyItems);
  const cancelOnlyItems = useSelector(getCancelOnlyItems);
  const cancelAndRefundItems = useSelector(getCancelAndRefundItems);

  const validItems = [...refundOnlyItems, ...cancelAndRefundItems, ...cancelOnlyItems];
  const allItems = selectedLineItems.length ? selectedLineItems : lineItemsOfSelectedOrder;
  const invalidItems = allItems.filter((item) => !validItems.some((validItem) => validItem.id === item.id));

  return (
    <>
      {!!cancelAndRefundItems.length && (
        <Spreadsheet className="fs-block">
          <SubTitleText>CANCEL AND REFUND ITEMS</SubTitleText>
          <HeaderRow>
            <ResultsColumnHeader>ITEM</ResultsColumnHeader>
            <ResultsColumnHeader>PRICE</ResultsColumnHeader>
          </HeaderRow>
          {cancelAndRefundItems.map((item) => (
            <Row key={JSON.stringify(item)} className="fs-block">
              <ResultsColumn>{getItemNameAndQuantity(item, orderingSystem)}</ResultsColumn>
              <ResultsColumn>{priceFormat(getItemPrice(item, orderingSystem))}</ResultsColumn>
            </Row>
          ))}
        </Spreadsheet>
      )}
      {!isEmpty(refundOnlyItems) && (
        <Spreadsheet className="fs-block">
          <SubTitleText>REFUND ITEMS</SubTitleText>
          <HeaderRow>
            <ResultsColumnHeader>ITEM</ResultsColumnHeader>
            <ResultsColumnHeader>PRICE</ResultsColumnHeader>
          </HeaderRow>
          {refundOnlyItems.map((item) => (
            <Row key={JSON.stringify(item)} className="fs-block">
              <ResultsColumn>{getItemNameAndQuantity(item, orderingSystem)}</ResultsColumn>
              <ResultsColumn>{priceFormat(getItemPrice(item, orderingSystem))}</ResultsColumn>
            </Row>
          ))}
        </Spreadsheet>
      )}
      {!isEmpty(cancelOnlyItems) && (
        <Spreadsheet className="fs-block">
          <SubTitleText>CANCEL ITEMS</SubTitleText>
          <HeaderRow>
            <ResultsColumnHeader>ITEM</ResultsColumnHeader>
            <ResultsColumnHeader>PRICE</ResultsColumnHeader>
          </HeaderRow>
          {cancelOnlyItems.map((item) => (
            <Row key={JSON.stringify(item)} className="fs-block">
              <ResultsColumn>{getItemNameAndQuantity(item, orderingSystem)}</ResultsColumn>
              <ResultsColumn>{priceFormat(getItemPrice(item, orderingSystem))}</ResultsColumn>
            </Row>
          ))}
        </Spreadsheet>
      )}
      {!isEmpty(invalidItems) && (
        <Spreadsheet className="fs-block">
          <SubTitleText>INVALID ITEMS</SubTitleText>
          <HeaderRow>
            <ResultsColumnHeader>ITEM</ResultsColumnHeader>
            <ResultsColumnHeader>PRICE</ResultsColumnHeader>
          </HeaderRow>
          {invalidItems.map((item) => (
            <Row key={JSON.stringify(item)} className="fs-block">
              <ResultsColumn>{getItemNameAndQuantity(item, orderingSystem)}</ResultsColumn>
              <ResultsColumn>{priceFormat(getItemPrice(item, orderingSystem))}</ResultsColumn>
            </Row>
          ))}
        </Spreadsheet>
      )}
    </>
  );
};
export default DTCancelAndRefundWidget;
